export const USER_ROLES = {
  ANONYMOUS: { ID: 1, NAME: 'anonymous user' },
  AUTHENTICATED: { ID: 2, NAME: 'authenticated user' },
  BUSINESS: { ID: 3, NAME: 'business' },
  DOCTOR: { ID: 4, NAME: 'doctor' },
  SUPER: { ID: 5, NAME: 'super' },
  SYSTEM: { ID: 6, NAME: 'system' },
  WEB: { ID: 7, NAME: 'lemonaid web user' },
  LEMONAID_DASHBOARD_USER: { ID: 8, NAME: 'lemonaid dashboard user' },
  QA_USER: { ID: 9, NAME: 'qa user' },
  LAB_RESULTS_PROVIDER: { ID: 10, NAME: 'lab results provider' },
  MAILORDER_PROVIDER: { ID: 11, NAME: 'mailorder provider' },
  STAFF_MANAGER: { ID: 12, NAME: 'staff manager' },
  PHARMACIST: { ID: 13, NAME: 'pharmacist' },
  SUPERVISING_DOCTOR: { ID: 18, NAME: 'supervising doctor' },
  DOCTOR_ADMIN: { ID: 15, NAME: 'doctor admin' },
  BUSINESS_ADMIN: { ID: 16, NAME: 'business admin' },
  STORE_PORTAL_USER: { ID: 22, NAME: 'store portal user' },
  // 1: "anonymous user",
  // 2: "authenticated user",
  // 3: "business",
  // 4: "doctor",
  // 5: "super",
  // 6: "system",
  // 7: "lemonaid web user"
  // 8: "lemonaid dashboard user"
  // 9: "qa user"
  // 10: "lab results provider"
  // 11: "mailorder provider"
  // 12: "staff manager"
  // 13: "pharmacist"
};